import { observable, action, makeAutoObservable  } from 'mobx'
import { ReactComponent as Book } from '../svg/book.svg'
import { ReactComponent as PlusIcon } from '../svg/plus-icon.svg'
import { ReactComponent as Facebook } from '../svg/facebook-icon.svg'
import { ReactComponent as Instagram } from '../svg/instagram-icon.svg'
import { ReactComponent as Youtube } from '../svg/youtube-icon.svg'
import { ReactComponent as Pintrest } from '../svg/pinterest-icon.svg'
import { ReactComponent as Twitter } from '../svg/twitter-icon.svg'
import { ReactComponent as Linkedin } from '../svg/linkedin.svg'
import { ReactComponent as Gift } from '../svg/gift.svg'
import { TemplateItem } from './componentStore'
import { getDefaultTemplates } from '../services/ElementService'
import { getAdminCategories, getPublicDesigns, getUserDesigns } from '../services/DesignService'

class TemplateStore {

  @observable workAreaStore

  constructor(workAreaStore, errorStore) {
    makeAutoObservable(this);
    this.workAreaStore = workAreaStore
    this.errorStore = errorStore
  }

  igBG = 'linear-gradient(237.26deg, #F7EBFF 0%, #FFF4F9 50%, #FFF6E0 100%)'
  fbBG = '#F5F9FF'
  twitterBG = '#F5F9FF'
  pintrestBG = '#FDECEF'
  youtubeBG = '#FFF2F2'

  defaultsLoading = false
  defaults = null
  keyword = ''
  templateItems = [
    new TemplateItem('instagram', 'instagram post', <Instagram />, '', 1024, 1024, 0.45, '#ffffff', 'social'),
    new TemplateItem('instagram', 'instagram story', <Instagram />, '', 1080, 1920, 0.45, '#ffffff', 'social'),
    new TemplateItem('book', 'book templates', <Book />, '', 1000, 1600, 0.4, '#ffffff', 'marketing'),
    new TemplateItem('twitter', 'twitter templates', <Twitter />, '', 1500, 500, 0.5, '#ffffff', 'social', ),
    new TemplateItem('facebook', 'facebook templates', <Facebook />, '', 1200, 630, 0.5, '#ffffff', 'social'),
    new TemplateItem('facebook', 'facebook story', <Facebook />, '', 1080, 1920, 0.5, '#ffffff', 'social'),
    new TemplateItem('linkedin', 'linkedin templates', <Linkedin />, '', 1200, 1200, 0.5, '#ffffff', 'social'),
    new TemplateItem('pintrest', 'pintrest templates', <Pintrest />, '', 1000, 1500, 0.4, '#ffffff', 'social'),
    new TemplateItem('greeting', 'greeting templates', <Gift/>, '', 1080, 1920, 0.4, '#ffffff', 'marketing'),
    new TemplateItem('banner', 'banner templates', <Gift />, '', 1080, 1920, 0.4, '#ffffff', 'marketing'),
    new TemplateItem('logo', 'logo templates', <Gift />, '', 500, 500, 0.7, '#ffffff', 'marketing'),
  ]
  userDesigns = []
  noUserDesigns = false
  userDesignsLoading = false

  teamDesigns = []
  noTeamDesigns = false
  teamDesignsLoading = false

  categoriesFetched = false
  publicDesigns = {
    'free-templates': {
      page: 0,
      designs: [],
      category: 'free-templates',
      empty: false,
      more: true,
      loading: false,
      full: false
    },
    'facebook-post': {
      page: 0,
      category: 'facebook-post',
      designs: [],
      empty: false,
      more: true,
      loading: false,
      full: false,
    },
    'instagram-story': {
      page: 0,
      category: 'instagram-story',
      designs: [],
      empty: false,
      more: true,
      loading: false,
      full: false,
    },
    'linkedin-post': {
      page: 0,
      category: 'linkedin-post',
      designs: [],
      empty: false,
      more: true,
      loading: false,
      full: false,
    },
    'twitter-post': {
      page: 0,
      category: 'twitter-post',
      designs: [],
      empty: false,
      more: true,
      loading: false,
      full: false,
    },
    'logo': {
      page: 0,
      category: 'logo',
      designs: [],
      empty: false,
      more: true,
      loading: false,
      full: false,
    },
    't-shirt': {
      page: 0,
      category: 't-shirt',
      designs: [],
      empty: false,
      more: true,
      loading: false,
      full: false,
    },
    'youtube-channel-art': {
      page: 0,
      category: 'youtube-channel-art',
      designs: [],
      empty: false,
      more: true,
      loading: false,
      full: false
    },
    'certificate': {
      page: 0,
      category: 'certificate',
      designs: [],
      empty: false,
      more: true,
      loading: false,
      full: false
    },
    'album-cover': {
      page: 0,
      category: 'album-cover',
      designs: [],
      empty: false,
      more: true,
      loading: false,
      full: false
    }
  }
  columnView = false
  columnKey = null


  async populateUserDesigns(keyword, team = null){
    if(team){
      this.teamDesignsLoading = true
    }else{
      this.userDesignsLoading = true
    }
    const prevKeyword = this.keyword
    this.keyword = keyword
    try{
      if(keyword && keyword.length < 3){
        return
      }
      if((prevKeyword && !keyword) || (prevKeyword && !keyword.length)){
        this.populatePublicDesigns(true)
      }
      if(keyword && keyword.length >= 3){
        this.populatePublicDesigns(true)
      }
      const data = await getUserDesigns(this.keyword, team)
      const filtered = data.designs.filter(({ data }) => data.id !== this.workAreaStore.designId)
      if(team){
        this.teamDesigns = filtered
      }else{
        this.userDesigns = filtered
      }
      if(filtered.length === 0){
        if(team){
          this.noTeamDesigns = true
        }else{
          this.noUserDesigns = true
        }
      }else{
        if(team){
          this.noTeamDesigns = false
        }else{
          this.noUserDesigns = false
        }
      }
      if(team){
        this.teamDesignsLoading = false
      }else{
        this.userDesignsLoading = false
      }
    }catch(err){
      console.log(err)
    }
  }

  togglePublicTemplatesColumn(key, status){
    this.columnView = status
    if(status){
      this.columnKey = key
    }else{
      this.columnKey = null
    }
  }

  setPublicLoading(status){
    Object.keys(this.publicDesigns).forEach(key => {
      this.publicDesigns[key].loading = status
    })
  }

  async populatePublicDesigns(keywordReset = false){
    try{
      const pub = {}
      this.setPublicLoading(true)
      if(keywordReset){
        Object.keys(this.publicDesigns).map(key => {
          this.publicDesigns[key].designs = []
          this.publicDesigns[key].page = 0
          this.publicDesigns[key].empty = false
        })
      }
      if(!this.categoriesFetched){
        const { categoryList } = await getAdminCategories(true)
        const publicDesignList = {
          'free-templates': {
            page: 0,
            count: 0,
            designs: [],
            category: 'free-templates',
            empty: false,
            more: true,
            loading: true,
            title: 'Free templates',
            full: false
          },
        }
        if(categoryList && categoryList.length){
          categoryList.forEach(category => {
            publicDesignList[category.slug] = {
              page: 0,
              count: category.count,
              designs: [],
              category: category.slug,
              empty: false,
              more: true,
              loading: true,
              title: category.name,
              full: false
            }
          })
        }
        this.publicDesigns = publicDesignList
        this.categoriesFetched = true
      }
      await Promise.all(Object.keys(this.publicDesigns).map(async key => {
        const template = this.publicDesigns[key]
        const data = await getPublicDesigns(template.category, template.page, this.keyword)
        const idMap = this.publicDesigns[key].designs.map(({ id }) => id)
        const filtered = data.designs.filter(({ id }) => !idMap.includes(id))
        pub[key] = {
          ...template,
          page: 0,
          empty: data.designs.length === 0 && this.publicDesigns[key].designs.length === 0,
          designs: filtered,
          more: data.isMore
        }
      }))
      this.publicDesigns = pub
    }catch(err){
      console.log(err)
      this.errorStore.setErrorMessage('Failed to load public designs', true)
      this.setPublicLoading(false)
    }finally{
      this.setPublicLoading(false)
    }
  }

  async paginatePublicDesigns(key){
    try{
      this.publicDesigns[key].loading = true
      this.publicDesigns[key].page += 1
      const data = await getPublicDesigns(this.publicDesigns[key].category, this.publicDesigns[key].page, this.keyword)
      this.publicDesigns[key].more = data.isMore
      const idMap = this.publicDesigns[key].designs.map(({ id }) => id)
      const filtered = data.designs.filter(({ id }) => !idMap.includes(id))
      filtered.forEach(design => {
        this.publicDesigns[key].designs.push(design)
      })
    }catch(err){
      console.log(err)
      this.errorStore.setErrorMessage('Failed to load public designs', true)
      this.publicDesigns[key].loading = false
    }finally{
      this.publicDesigns[key].loading = false
    }
  }

  async fetchDefaultTemplates(){
    try{
      this.defaultsLoading = true
      const { data } = await getDefaultTemplates()
      this.defaults = data
    }catch(err){
      console.log(err)
    }finally{
      this.defaultsLoading = false
    }
  }

}

export default TemplateStore